export const supplierCatalogFormSchema = {
  type: 'object',
  required: ['name', 'supplierId'],
  properties: {
    name: { type: 'string', minLength: 6, maxLength: 255 },
  },
};
